/**
 * 统一消息渲染组件导出
 */

// 核心组件
import UnifiedMessageRenderer from './UnifiedMessageRenderer.vue';
import StreamingRenderer from './StreamingRenderer.vue';
import MessageTypeAdapter from './MessageTypeAdapter';

// 渲染器组件
import MarkdownRenderer from './renderers/MarkdownRenderer.vue';

// 测试组件（仅开发环境）
let MessageRendererDemo = null;
if (process.env.NODE_ENV === 'development') {
  MessageRendererDemo = require('./MessageRendererDemo.vue').default;
}

// 导出组件
export {
  UnifiedMessageRenderer,
  StreamingRenderer,
  MessageTypeAdapter,
  MarkdownRenderer,
  MessageRendererDemo
};

// 默认导出
export default UnifiedMessageRenderer;

/**
 * Vue 插件安装函数
 * 使用方式：
 * import MessageRenderer from '@/components/message';
 * Vue.use(MessageRenderer);
 */
export const install = function(Vue) {
  // 注册全局组件
  Vue.component('UnifiedMessageRenderer', UnifiedMessageRenderer);
  Vue.component('StreamingRenderer', StreamingRenderer);
  Vue.component('MarkdownRenderer', MarkdownRenderer);
  
  // 添加全局方法
  Vue.prototype.$messageAdapter = MessageTypeAdapter;
  
  // 开发环境注册测试组件
  if (process.env.NODE_ENV === 'development' && MessageRendererDemo) {
    Vue.component('MessageRendererDemo', MessageRendererDemo);
  }
};

// 自动安装（用于通过 script 标签引入）
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use({ install });
}